import React, { useState, useEffect } from "react";
import { useDispatch  } from "react-redux";

import store from "../../../../store";
import useHttp from "../../../../hooks/useHttp";
import SideBar from "./SideBar";
import { GET_USER_PROFILE_VALUE_URL } from "../../../../utils/api-ends";
import { progressing_status } from "../../../../store/slices/progessingRequest";
import { isFavoriteValue } from "../../../../store/slices/favorite";
import Skeleton from "@mui/material/Skeleton";

const BasicInfo = ({ userID }) => {
  const [userProfileData, setUserProfileData] = useState({});
  const { error, isLoading, sendRequests } = useHttp();
  const dispatch = useDispatch();
  const [profileErrorMessage, setProfileErrorMessage] = useState("");

  useEffect(() => {
    const response = (data) => {
      setUserProfileData(data);
      store.dispatch(
        isFavoriteValue({
          favoriteValue: data.is_favorite,
        })
      );
    };

    // Send request to get profile info
    sendRequests(
      {
        url: GET_USER_PROFILE_VALUE_URL(userID),
        method: "GET",
      },
      response
    );
  }, [userID, sendRequests]);

  useEffect(() => {
    dispatch(progressing_status(isLoading));
  }, [isLoading , dispatch]);

  useEffect(() => {
    if (error) {
      if (error.message) {
        setProfileErrorMessage(error.message);
      }
    }
  }, [error]);

  return (
    <section id="profile-info">
      <div className="container theme-section">
        <div className="row">
          <p className="auth-error">{profileErrorMessage}</p>

          <SideBar
            userProfileData={userProfileData}
            setUserProfileData={setUserProfileData}
          />

          <div className="col-lg-9">
            <div className="box-div-marggin-bottom">
              <div className="row profile-info-section-wrapper position-relative">
                {!userProfileData && (
                  <Skeleton animation="wave" className="card-animation" />
                )}

                <div className="col-lg-4 profile-info-boxes">
                  <label>Name</label>
                  <p>
                    {userProfileData?.first_name} {userProfileData?.last_name}
                  </p>
                </div>

                {userProfileData?.own_profile === true && (
                  <div className="col-lg-4 profile-info-boxes">
                    <label>Email</label>
                    <p>{userProfileData?.email}</p>
                  </div>
                )}

                {userProfileData?.own_profile === true && (
                  <div className="col-lg-4 profile-info-boxes">
                    <label>Phone</label>
                    <p>{userProfileData?.phone_number}</p>
                  </div>
                )}

                <div className="col-lg-4 profile-info-boxes">
                  <label>Country</label>
                  <p>{userProfileData?.country}</p>
                </div>

                <div className="col-lg-4 profile-info-boxes">
                  <label>State</label>
                  <p>{userProfileData?.state}</p>
                </div>

                <div className="col-lg-4 profile-info-boxes">
                  <label>City</label>
                  <p>{userProfileData?.city}</p>
                </div>

                <div className="col-lg-4 profile-info-boxes">
                  <label>Zip Code</label>
                  <p>{userProfileData?.zip_code}</p>
                </div>

                {userProfileData?.own_profile === true && (
                  <div className="col-lg-4 profile-info-boxes">
                    <label>Street Address</label>
                    <p>{userProfileData?.street_address}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BasicInfo;
